import React from 'react';

import Select from 'react-select';

import approvalStatus from '@/data/approvalStatus';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectApprovalStatus: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={approvalStatus.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={approvalStatus}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectApprovalStatus;
